@use '../colors.scss' as colors;

.info-group {
  margin-top: 0.5em;
  border-bottom: 1px solid rgba(118, 118, 118, 0.25);
  display: flex;
}

.info-group-header {
  color: colors.$header;
}

.info-group-value {
  font-size: 0.9em;
  line-height: 19px;
  letter-spacing: -0.28px;
  flex-grow: 1;
  text-align: right;
  color: colors.$body-text;
}

// Flexpay
:global(.flexpay) {
  .info-group {
    padding: 16px 0;
    margin: 0;
    border-bottom: 1px solid colors.$flexpay-border;
  }

  .info-group-header {
    font-weight: 500;
  }

  .info-group-value {
    font-size: 16px;
  }

  .info-group-header,
  .info-group-value {
    color: colors.$flexpay-title;
  }
}
